import { Button, Colors } from '@blueprintjs/core';
import styled from 'styled-components';

// Componentes estilizados
export const FullScreenCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
  background: transparent;
  max-width: 390px;
  @media (min-width: 390px) {
    width: 90%;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100vw;
`;

export const ButtonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 10px;
`;

export const RoundButton = styled.div<{ $backgroudColor?: string }>`
  border-radius: 50%;
  max-width: 80px;
  max-height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  font-size: 50px;
  color: ${Colors.DARK_GRAY3};
  background-color: ${(props) =>
    props.$backgroudColor ? props.$backgroudColor : Colors.WHITE};

  &:active {
    transform: translateY(4px);
  }
`;

export const BottomRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const Display = styled.div`
  background-color: ${Colors.WHITE};
  color: ${Colors.DARK_GRAY3};
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
  text-align: center;
  font-size: 3em;
`;

interface UsernameDisplayProps {
  $editable: boolean;
}

export const UsernameDisplay = styled(Display)<UsernameDisplayProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) =>
    props.$editable ? Colors.WHITE : Colors.DARK_GRAY3};
  color: ${(props) => (props.$editable ? Colors.DARK_GRAY3 : Colors.WHITE)};
  width: 100%;
`;

export const DisplayLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 10px;
  margin: 0 auto;
`;

export const UsernameRawDisplay = styled.div`
  font-size: 0.5em;
`;

export const UsernameRawInput = styled.input`
  font-size: 0.5em;
  flex: 1;
  margin-right: '10px';
  box-sizing: 'border-box';
`;

export const EditUserButton = styled(Button)`
  flex-shrink: 0;
  width: 50px;
  height: 50px;
`;
